module.exports = __webpack_public_path__ + "static/media/banner-video-bg.df01c962.png";